import React, { useState, useEffect } from 'react';
import player1Image from '../../assets/images/player_1.png';
import player2Image from '../../assets/images/player_2.png';

function ChoosingStones() {
  const [diceValue, setDiceValue] = useState(null);
  const [stonesPosition, setStonesPosition] = useState('center'); // 'center', 'distributed'

  useEffect(() => {
    const startAnimation = () => {
      // Start rolling
      const rollInterval = setInterval(() => {
        setDiceValue(Math.floor(Math.random() * 6) + 1);
      }, 100);

      // Stop rolling after 2 seconds
      setTimeout(() => {
        clearInterval(rollInterval);

        // Move stones to players
        setTimeout(() => {
          setStonesPosition('distributed');

          // Reset after showing distributed stones for 2 seconds
          setTimeout(() => {
            setStonesPosition('center');
            setDiceValue(null);
            startAnimation(); // Restart the animation
          }, 2000);
        }, 500);
      }, 2000);
    };

    startAnimation();

    return () => {
      // Cleanup will be handled by the timeouts
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div className="flex flex-col items-center gap-8">
      {/* Players */}
      <div className="flex justify-between items-center w-full max-w-2xl">
        <div className="flex flex-col items-center">
          <img src={player1Image} alt="Player 1" className="w-32 h-32 object-contain" />
          <span className="text-white mt-2">Player 1</span>
        </div>

        {/* Dice */}
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 bg-white rounded-lg shadow-lg flex items-center justify-center">
            {diceValue && (
              <div className="grid grid-cols-3 gap-0.5 p-1.5">
                {Array(9).fill(null).map((_, i) => (
                  <div
                    key={i}
                    className={`w-2 h-2 rounded-full ${[
                      [4],
                      [0, 8],
                      [0, 4, 8],
                      [0, 2, 6, 8],
                      [0, 2, 4, 6, 8],
                      [0, 2, 3, 5, 6, 8]
                    ][diceValue - 1].includes(i)
                      ? 'bg-black'
                      : 'bg-transparent'
                      }`}
                  />
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col items-center">
          <img src={player2Image} alt="Player 2" className="w-32 h-32 object-contain" />
          <span className="text-white mt-2">Player 2</span>
        </div>
      </div>

      {/* Stones Container */}
      <div className="relative w-full max-w-2xl h-16">
        {/* Black Stones */}
        <div className={`absolute left-1/2 -translate-x-1/2 flex gap-1.5 transition-all duration-1000 ${stonesPosition === 'distributed' ? 'left-[20%]' : ''
          }`}>
          {Array(4).fill(null).map((_, i) => (
            <div
              key={i}
              className="shadow-sm shadow-white w-5 h-5 rounded-full bg-black"
            />
          ))}
        </div>

        {/* White Stones */}
        <div className={`absolute mt-8 left-1/2 -translate-x-1/2 flex gap-1.5 transition-all duration-1000 ${stonesPosition === 'distributed' ? 'left-[80%]' : ''
          }`}>
          {Array(4).fill(null).map((_, i) => (
            <div
              key={i}
              className="shadow-sm shadow-black w-5 h-5 rounded-full bg-white"
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default ChoosingStones; 
